document.getElementsByClassName("section")[1].style.margin = "5px 0";
document.getElementsByClassName("section")[2].style.margin = "5px 0";



//setTimeout(function(){ applyData(bankdata);}, 200);
//fetch("https://api.fidesmo.com/v1/supported_banks.json").then(res => res.json()).then(applyData);
fetch("https://api.fidesmo.com/v2/pay/supported_banks.json",{
  method: 'GET', // or 'POST', 'PUT', etc.
  headers: {
    'Accept-Language': 'en-US,en;q=0.9', // Set the Accept-Language header
    'Content-Type': 'application/json',  // Example of another header
  }}).then(res => res.json()).then(applyData);


function applyData(parsedData) {
        const seen = new Set();
        let hintDropped = false;
        const filtered = parsedData.filter(item => {
            const duplicate = seen.has(item.country.toLowerCase());
            seen.add(item.country.toLowerCase());
            return !duplicate;
        })
        const cardsContainer = document.getElementById("supported_banks")
        filtered.map((item) => {
            const country = document.createElement("div")
            country.id = `country-${item.country}-description`
            country.className = "product-tabs__tab-item-wrapper"
            country.innerHTML = `<button is="toggle-button" aria-expanded="false" aria-controls="country-${item.country}-content" class="collapsible-toggle heading heading--small">${item.country}<svg focusable="false" width="12" height="8" class="icon icon--chevron   " viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1"></path></svg></button>`
            const issuerContainer = document.createElement("collapsible-content")
            issuerContainer.id = `country-${item.country}-content`
            issuerContainer.className = "collapsible show"
            country.appendChild(issuerContainer)
            cardsContainer.appendChild(country)

            const seen = []
            parsedData.map(bank => {
                if (bank.country === item.country) {
                    if (seen.indexOf(bank.issuer_name) < 0) {
                        seen.push(bank.issuer_name)
                        
                      if(item.country.indexOf('Germany') !== -1 && !hintDropped)
                        {
                          const bankHint = document.createElement("span");
                          bankHint.className = "draw-me-red";
                          console.log("  ");
                          //console.log(Shopify.checkout.customer_locale);
                          if(document.documentElement.getAttribute('lang').indexOf('de') !== -1) {
                            bankHint.innerHTML = "Deine Bank ist hier nicht aufgeführt?<br />";
                            bankHint.innerHTML += "Verbinde ganz einfach jede Visa und Mastercard über Curve mit deinem PAYCELET.<br /><br />";
                          } else {
                            bankHint.innerHTML = "Your bank is not listed here?<br />";
                            bankHint.innerHTML += "Simply connect any Visa and Mastercard to your PAYCELET via Curve.<br /><br />";
                          }
                          issuerContainer.appendChild(bankHint);
                          hintDropped = true;
                        }
                    
                        const issuerName = document.createElement("div")
                        issuerName.className = "product-tabs__tab-item-content rte bank_entry"
                      
                        issuerName.innerHTML = `<h6>${bank.issuer_name}</h6>`

                        issuerContainer.appendChild(issuerName)

                        const cardsContainer = document.createElement("div")
                        cardsContainer.className = "cards-container"
                        cardsContainer.id = `cards-${bank.issuer_name}`
                        issuerName.appendChild(cardsContainer)


                        parsedData.map(entry => {
                            if (entry.issuer_name === bank.issuer_name && entry.country === item.country) {
                                const cardName = document.createElement("div")
                                cardName.className="bank_sub_entry"
                                if(entry.country.indexOf('Germany') !== -1 && entry.card_name.indexOf('All Curve cards') !== -1)
                                {
                                  cardName.className += " draw-me-red";
                                }
                                cardName.innerHTML = entry.card_name
                                cardsContainer.appendChild(cardName)

                              /*if (entry.logo) {
                                  const logoImage = document.createElement("img");
                                  logoImage.src = entry.logo;
                                  logoImage.style.height = "25px";
                                  cardsContainer.appendChild(logoImage);
                                }*/

                                if (entry.note) {
                                    const note = document.createElement("span")
                                    note.style.display = "block"
                                    note.style.fontSize = "12px"
                                    
                                    if(entry.country.indexOf('Germany') !== -1 && entry.card_name.indexOf('All Curve cards') !== -1)
                                    {
                                      note.className = "draw-me-red";
                                    }
                                    
                                    note.innerHTML += entry.note
                                  
                                    cardsContainer.appendChild(note)
                                }
                            }
                        })
                    }
                }
            })

        })
    }